import { useState } from "react";
import { useDispatch } from "react-redux";
import { setToken } from "../../app/services/user.slice"; // adjust path
import { useNavigate,useLocation } from 'react-router-dom';
import {
  Grid,
  Typography,
  Link,
  TextField,
  Button,
  FormControlLabel,
  Switch,
  InputAdornment,  
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { authenticationService } from "../../app/services";
import "../../assets/styles/sharedstyle.css";
import image from "../../assets/images/logo.png";
import {  PersonOutlineOutlined } from "@mui/icons-material";
import useWindowResizeListener from "../../helpers/useWindowResizeListener";
import { useTranslation } from 'react-i18next';

const CustomTextField = (props) => (
  <TextField variant="outlined" {...props} fullWidth required />
);

const LoginPage = () => {
  const { height } = useWindowResizeListener();
  const [errorMessage, setErrorMessage] = useState("");
  const [showResetPopup, setShowResetPopup] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const history = useHistory();|| '/schedule'
  const location = useLocation();
  
  console.log("loading loginpage");
  
  console.log(location);
  
  const returnUrl = location.state?.from ;

  const openResetPopup = () => {
    setShowResetPopup(true);
  };

  const closeResetPopup = () => {
    setShowResetPopup(false);
  };

  const handleSubmit = async (values, { setSubmitting }) => {
  try {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}))$/;
    let username = "";
    let email = "";
    if (re.test(values.username)) {
      email = values.username;
    } else {
      username = values.username;
    }
    await authenticationService
      .login(username, email, values.password, "")
      .then(
        (user) => {
          if (user?.token) {
            dispatch(setToken(user.token));
          }
          const redirectTo = location.state?.from || "/companies";
          navigate(redirectTo, { replace: true });
        },
        (error) => {
          setErrorMessage(error.message);
        }
      );
  } catch (error) {
    setErrorMessage(error.message);
  } finally {
    setSubmitting(false);
  }
};

  const handleForgotPassword = async (values, event) => {

    try {
      await authenticationService
      .resetPassword(values.email) // assuming username holds the email value
      .then(
        (user) => {
          alert(t('LoginRegisterPage.Password_reset_email_sent'));

        },
        (error) => {
          setErrorMessage(error.message);
        }
      );
    } catch (error) {
      console.error('Error sending password reset email', error);
      alert(t('LoginRegisterPage.Error_sending_password_reset_email'));
    }
};

  const btnstyle = { margin: "8px 0" };

  return (
    <div className="login-page" style={{ height: height }}>
      <Formik
        initialValues={{
          username: "",
          password: "",
          remember: false
        }}
        validationSchema={Yup.object().shape({
          username: Yup.string().required(t('LoginRegisterPage.Required')),
          password: Yup.string().required(t('LoginRegisterPage.Required')),
        })}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <div align="center" style={{ minHeight: height, width: "100%" }}>
            <Grid
              container
              spacing={12}
              style={{ height: "100%", Padding: "0px!important" }}
            >
              <Grid
                item
                xs={12}
                style={{
                  marginTop: "4.5%",
                  height: "100vh",
                  background: "#fafafa",
                }}
              >
                <Grid style={{ paddingTop: "10px", paddingBottom: "50px" }}>
                  <Link
                    href="/"
                    style={{ width: "200px", height: "110px", offset: "999" }}>
                    <img src={image} alt="img" style={{ width: "11em" }} />
                  </Link>
                </Grid>
                <Grid>
                  {/* Google and Apple login buttons style={{ width: '50%' }}*/}
                </Grid>
                {errorMessage && (
                  <div className="error-message">{errorMessage}</div>
                )}

                <br />
                <Grid className="auth-wrapper">
                  <Typography variant="h5">{t('LoginRegisterPage.Welcome_back')}</Typography>
                  <Typography variant="h6">{t('LoginRegisterPage.Sign_in')}</Typography>
                  <Form spacing={4}>
                    <Field
                      align="center"
                      as={CustomTextField}
                      name="username"
                      placeholder={t('LoginRegisterPage.Enter_username_or_email')}
                      helperText={<ErrorMessage name="username" />}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <PersonOutlineOutlined />
                          </InputAdornment>
                        ),
                      }}
                    />
                    <Field
                      as={CustomTextField}
                      align="center"
                      name="password"
                      placeholder={t('LoginRegisterPage.Enter_password')}
                      type="password"
                      helperText={<ErrorMessage name="password" />}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <LockOutlinedIcon />
                          </InputAdornment>
                        ),
                      }}
                    />

                    <br />
                    {/*   <Field
                      as={FormControlLabel}
                      name='remember'
                      control={<Switch />}
                      label="Remember me"
                    /> */}

                <Link href="#" className="forgot-pass" onClick={openResetPopup}
                  sx={{
                    color: 'var(--uae-green)',
                    fontWeight: 600,
                    textDecoration: 'none',
                    '&:hover': { color: 'var(--uae-red)', textDecoration: 'underline' }
                  }}
                >
                {t('LoginRegisterPage.Forgot_password')}
                </Link>
      {/* Reset password popup */}
      <Dialog open={showResetPopup} onClose={closeResetPopup}>
      <DialogTitle>{t('LoginRegisterPage.Reset_Password')}</DialogTitle>
        <DialogContent>
          <Formik
            initialValues={{
              email: "",
            }}
            validationSchema={Yup.object().shape({
              email: Yup.string().email(t('LoginRegisterPage.Invalid_email')).required(t('LoginRegisterPage.Required')),
            })}
            onSubmit={(values, { setSubmitting }) => {
              // Handle reset password logic here
              handleForgotPassword(values);
              setSubmitting(false);
              closeResetPopup();
            }}
          >
            {({ isSubmitting }) => (
              <Form>
                <Field
                  as={TextField}
                  name="email"
                  label="Email"
                  variant="outlined"
                  fullWidth
                  required
                />
                <br />
                <ErrorMessage name="email" />

                <DialogActions>
                  <Button onClick={closeResetPopup}
                    sx={{ color: 'var(--uae-green)', '&:hover': { color: 'var(--uae-red)', backgroundColor: 'transparent' } }}
                  >
                    {t('LoginRegisterPage.Cancel')}
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={isSubmitting}
                    sx={{
                      backgroundColor: 'var(--uae-green)',
                      borderRadius: '9999px',
                      boxShadow: '0 8px 16px rgba(0,154,68,.18)',
                      '&:hover': { backgroundColor: 'var(--uae-green)' }
                    }}
                  >
                    {t('LoginRegisterPage.Reset_Password')}
                  </Button>
                </DialogActions>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
                  <br />
                    <Button
                      type="submit"
                      className="submit-btn"
                      variant="contained"
                      disabled={isSubmitting}
                      style={btnstyle}
                      sx={{
                        backgroundColor: 'var(--uae-green)',
                        color: '#fff',
                        borderRadius: '9999px',
                        paddingY: 1.2,
                        boxShadow: '0 8px 16px rgba(0,154,68,.18)',
                        '&:hover': { backgroundColor: 'var(--uae-green)' }
                      }}
                      fullWidth
                    >
                      {isSubmitting ? t('LoginRegisterPage.Loading') : t('LoginRegisterPage.Sign_in')}
                    </Button>
                  </Form>
                  <Typography className="signup-link">
                  {t('LoginRegisterPage.Dont_have_account')} <Link href="/register"
                    sx={{ color: 'var(--uae-green)', fontWeight: 700, textDecoration: 'none', '&:hover': { color: 'var(--uae-red)', textDecoration: 'underline' } }}
                  >
                    {t('LoginRegisterPage.Sign_up')}
                  </Link>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </div>
        )}
      </Formik>
    </div>
  );
};

export { LoginPage };





